import memo from "fast-memoize";
import fetch from "./fetch-trade-api";

import { TRUCK_REGEX, trimTruckString } from "./makes";

const vinAPI = async vin => {
  try {
    const resp = await fetch(`/v1/report/vehicle/vin/${vin}`);

    let {
      year: yearId,
      makeCode: makeId,
      modelCode: modelId,
      trimCode: trimId,
      makeDescription,
      ...rest
    } = await resp.json();

    if (TRUCK_REGEX.test(makeDescription)) {
      makeId = `${parseInt(makeId, 10) - 1}-${makeId}`;
      makeDescription = trimTruckString(makeDescription);
    }

    return {
      yearId: String(yearId),
      makeId: String(makeId),
      modelId: String(modelId),
      trimId: String(trimId),
      makeDescription,
      ...rest
    };
  } catch (e) {
    throw new Error(`Failed to find VIN`);
  }
};

export default memo(vinAPI);
